module.exports = __webpack_public_path__ + "static/media/icon-supplydrop-orange.36cf45a2.svg";